import { getFirebaseAuth } from "@/common/lib/firebase";
import { isSignInWithEmailLink, signInWithEmailLink } from "firebase/auth";

export function isAuthLink(href: string): boolean {
  return isSignInWithEmailLink(getFirebaseAuth(), href);
}

export async function completeEmailLinkSignIn(email: string, href: string): Promise<void> {
  await signInWithEmailLink(getFirebaseAuth(), email, href);
}
